import { createContext, useContext, useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "ma-lang-v1";
const LangCtx = createContext(null);

// -----------------------------------------------------------------------------
// Translation dictionary. Add new keys here — same key across DE/EN/RU.
// -----------------------------------------------------------------------------
const DICT = {
  de: {
    "nav.buchung": "Buchung",
    "nav.schulungen": "Schulungen",
    "nav.academy": "Academy",
    "portal.eyebrow": "Nur für Schülerinnen",
    "portal.title": "Academy · Interner Bereich",
    "portal.lock_body": "Dieser Bereich ist nur für Schülerinnen der Maschas Atelier Academy. Deinen persönlichen Zugangscode erhältst du am Schulungstag um 0:00 Uhr automatisch per E-Mail.",
    "portal.code_placeholder": "Zugangscode",
    "portal.unlock": "Freischalten",
    "portal.err_code": "Dieser Code ist leider nicht richtig.",
    "portal.welcome": "Willkommen im Academy-Bereich",
    "portal.hello": "Hallo {name} – schön, dass du da bist!",
    "portal.err_not_yet": "Dein Zugang wird am {date} um 0:00 Uhr freigeschaltet. Wir freuen uns auf dich!",
    "portal.err_expired": "Dein Zugang ist abgelaufen – er war ab deinem Schulungstag ein Jahr lang gültig. Bei Fragen melde dich gern im Studio.",
    "portal.body": "Hier findest du den Ablauf deiner Schulung, alles, was inklusive ist, und deine Schulungsunterlagen zum Herunterladen.",
    "portal.sec_ablauf": "Ablauf deiner Schulung",
    "portal.ablauf_t1": "Theorie: Aufbereitung & Sterilisation der Instrumente",
    "portal.ablauf_d1": "Reinigung, Desinfektion und Sterilisation – so arbeiten wir im Studio, und so ist es in Rheinland-Pfalz vorgeschrieben.",
    "portal.ablauf_t2": "Theorie: Anatomie des Nagels",
    "portal.ablauf_d2": "Aufbau, Wachstum und Besonderheiten des Naturnagels. Beide Theorieblöcke dauern zusammen ca. 2 Stunden.",
    "portal.ablauf_t3": "Gemeinsame Pause",
    "portal.ablauf_d3": "1 bis 1,5 Stunden – für Verpflegung ist gesorgt.",
    "portal.ablauf_t4": "Praxis: Arbeit an der Kundin / am Modell",
    "portal.ablauf_d4": "Vorbereitung des Nagels und anschließend der Farb- bzw. Gelauftrag – Schritt für Schritt gemeinsam.",
    "portal.sec_inklusive": "In deiner Schulung inklusive",
    "portal.inkl_1": "1:1-Intensivbetreuung",
    "portal.inkl_2": "Starterset mit Arbeitsmaterialien",
    "portal.inkl_3": "Zwei Zertifikate (persönliche Übergabe am Schulungstag)",
    "portal.inkl_4": "Verpflegung & ausführliche Pause (1–1,5 Stunden)",
    "portal.inkl_5": "Ein Jahr Nachbetreuung",
    "portal.inkl_6": "Alle Schulungsunterlagen als PDF",
    "portal.sec_materialien": "Schulungsunterlagen",
    "portal.materialien_hint": "Alle Unterlagen stehen dir ab deinem Schulungstag als PDF zum Herunterladen bereit.",
    "portal.m_sterilisation": "Aufbereitung & Sterilisation der Maniküre-/Pediküre-Instrumente",
    "portal.m_anatomie": "Anatomie des Nagels",
    "portal.m_vorbereitung": "Vorbereitung des Nagels",
    "portal.m_farbauftrag": "Farb- & Gelauftrag",
    "portal.sec_zertifikate": "Deine Zertifikate",
    "portal.zert_body": "Am Ende der Schulung erhältst du zwei Zertifikate. Beide händigen wir dir persönlich aus – sie stehen nicht zum Download bereit:",
    "portal.zert_1": "Zertifikat „Aufbereitung & Sterilisation von Instrumenten“ – nach dem Standard, den wir in unserem Studio praktizieren und der in Rheinland-Pfalz Pflicht ist.",
    "portal.zert_2": "Zertifikat für die erfolgreich absolvierte Schulung (Maniküre bzw. Pediküre).",
    "portal.empty": "Die Unterlagen hierzu werden in Kürze bereitgestellt.",
    "portal.lock_again": "Bereich wieder sperren",
    "nav.kontakt": "Kontakt",
    "nav.buchen_cta": "Termin buchen",
    "nav.terminanfrage": "Terminanfrage",

    "hero.tagline": "Wo Hygiene auf Ästhetik trifft.",
    "hero.tagline_opening": "Eröffnung am 01.09.2026.",
    "hero.title_a": "Russische",
    "hero.title_b": "Maniküre",
    "hero.subtitle": "Zeitloses Nageldesign & präzise Pflege. Studio & Academy in Koblenz.",
    "hero.cta_book": "Terminanfrage",
    "hero.cta_services": "Leistungen ansehen",
    "hero.cta_academy": "Schulung buchen",

    "about.eyebrow": "Über uns",
    "about.title": "Schönheit im Detail — mit Ruhe und Sorgfalt.",
    "about.body": "Maschas Atelier ist ein Ort für alle, die Wert auf Präzision und Pflege legen. Wir verbinden die russische Nageltechnik mit einem minimalistischen, ruhigen Ambiente — damit jeder Termin sich wie eine kleine Auszeit anfühlt. Bald auch mit weiteren kosmetischen Behandlungen.",
    "about.ch1_title": "Russische Maniküre",
    "about.ch1_text": "Millimetergenaue Arbeit an der Nagelhaut für ein makelloses, langanhaltendes Ergebnis.",
    "about.ch2_title": "Russische Pediküre",
    "about.ch2_text": "Inklusive Hornhautpflege, Peeling und Abschlusspflege — für gepflegte, entspannte Füße.",
    "about.ch3_title": "Schulungen & Academy",
    "about.ch3_text": "Wissen weitergeben: Kurse und Workshops folgen in Kürze.",

    "svc.from": "Ab",
    "svc.manikure_title": "Russische Maniküre",
    "svc.pedikure_title": "Russische Pediküre",
    "svc.schulungen_title": "Schulungen & Academy",
    "svc.soon": "Jetzt anfragen",

    "prices.eyebrow": "Preisliste",
    "prices.title": "Leistungen & Preise",
    "prices.cta": "Termin buchen",
    "prices.grp_manikure": "Maniküre",
    "prices.grp_pedikure": "Pediküre",
    "prices.grp_addons": "Add-ons",
    "prices.grp_manikure_note": "Alle Maniküren inkl. Russischer Maniküre (Nagelhautpflege).",
    "prices.grp_pedikure_note": "Alle Pediküren inkl. Hornhautpflege, Peeling & Abschlusspflege.",
    "prices.duration_manikure": "ca. 75 Min.",
    "prices.duration_pedikure": "ca. 60 Min.",
    "prices.duration_optional": "optional",

    "item.russ_manikure": "Russische Maniküre",
    "item.russ_manikure_desc": "Perfekt, wenn man die natürlichen Nägel etwas gepflegter haben möchte – z. B. ideal für Männer.",
    "item.nail_extension_natural": "Nagelverstärkung Natur/Milky/Pink",
    "item.nail_extension_color": "Nagelverstärkung inkl. Farbe",
    "item.nail_extension_french": "Nagelverstärkung inkl. French",
    "item.russ_pedikure": "Russische Pediküre",
    "item.russ_pedikure_nude": "Russische Pediküre inkl. Nude/Pink Base",
    "item.russ_pedikure_shellac": "Russische Pediküre inkl. Shellac",
    "item.russ_pedikure_french": "Russische Pediküre inkl. French",
    "item.removal": "Entfernung der Nägel",
    "item.chrome": "Chrome Pigment",
    "item.french_per_nail": "French pro Nagel",
    "item.polkadot_full": "Polkadot Full Cover",
    "item.polkadot_french": "Polkadot auf French pro Nagel",
    "item.full_french_set": "10 Finger oder 10 Zehen French",

    "hours.eyebrow": "Öffnungszeiten",
    "hours.title": "Für dich da",
    "hours.cta": "Termin anfragen",
    "hours.days_short": "Mo – Fr",
    "hours.time": "09:00 – 17:00",
    "hours.payment_label": "Zahlungsoptionen",
    "hours.payment_body": "Bezahlung bequem vor Ort mit ",
    "hours.payment_body_strong": "Karte oder bar",
    "hours.cta_eyebrow": "Dein Termin",
    "hours.cta_title": "Bereit für schöne Nägel?",
    "hours.cta_body": "Sende unverbindlich deine Terminanfrage — wir bestätigen dir den Termin per E-Mail. Für eine sofort verbindliche Buchung kannst du online über Shore bezahlen.",
    "hours.cta_button": "Jetzt Termin buchen",

    "day.mo": "Montag",
    "day.di": "Dienstag",
    "day.mi": "Mittwoch",
    "day.do": "Donnerstag",
    "day.fr": "Freitag",
    "day.sa": "Samstag",
    "day.so": "Sonntag",
    "day.closed": "Geschlossen",

    "team.eyebrow": "Das Atelier wächst",
    "team.title": "Unser Team",
    "team.body": "Hinter jeder Behandlung steht Sorgfalt, Erfahrung und Leidenschaft. Bald begrüßen wir weitere Nageldesignerinnen — für dich bedeutet das mehr Termine, dieselbe Qualität.",
    "team.hiring_eyebrow": "Wir suchen Verstärkung",
    "team.hiring_title": "Dein Platz?",
    "team.hiring_body": "Du liebst Präzision, Hygiene und die kleinen Details, die Schönheit ausmachen – ob an Nägeln, Wimpern, Augenbrauen oder der Haut? Dann werde Teil unseres Ateliers.",
    "team.hiring_cta": "Jetzt bewerben →",

    "portfolio.eyebrow": "@maschasatelier",
    "portfolio.title": "Portfolio",
    "portfolio.body": "Aktuelle Arbeiten aus dem Atelier — tippe auf ein Bild, um es größer zu sehen.",
    "portfolio.follow": "Auf Instagram folgen",

    "beforeafter.eyebrow": "Vorher / Nachher",
    "beforeafter.title": "Handwerk sichtbar gemacht",
    "beforeafter.body": "Ziehe den Regler zur Seite — von unbehandelt zu makellos.",

    "reviews.eyebrow": "Bewertungen",
    "reviews.title": "Was Kundinnen sagen",
    "reviews.write": "Bewertung schreiben",
    "reviews.on_google": "Auf Google bewerten",
    "reviews.name": "Dein Name",
    "reviews.text": "Deine Erfahrung…",
    "reviews.submit": "Bewertung veröffentlichen",
    "reviews.photos": "Fotos hinzufügen",

    "social.eyebrow": "Google Bewertungen",
    "social.title": "Was Kundinnen sagen",
    "social.placeholder": "Google-Link folgt",

    "location.eyebrow": "So findest du uns",
    "location.title": "Anfahrt & Lage",
    "location.route": "Route planen",
    "location.note": "Gut zu Fuß von der Koblenzer Innenstadt erreichbar. Parkmöglichkeiten in der Umgebung.",
    "location.consent_title": "Karte ausgeblendet",
    "location.consent_body": "Beim Laden der Karte werden Daten (u.a. deine IP-Adresse) an Google übertragen. Details siehe Datenschutzerklärung.",
    "location.consent_cta": "Karte laden",

    "hours.eyebrow": "Öffnungszeiten",
    "hours.title": "Für dich da",
    "hours.cta": "Termin anfragen",
    "hours.days_short": "Mo – Fr",
    "hours.time": "09:00 – 17:00",

    "footer.contact": "Kontakt",
    "footer.hours": "Öffnungszeiten",
    "footer.social": "Social",
    "footer.legal": "Rechtliches",

    "cookie.title": "Cookies & Datenschutz",
    "cookie.body": "Wir verwenden nur technisch notwendige Cookies, damit unsere Seite funktioniert. Kein Tracking, keine Analyse-Tools. Details findest du in unserer",
    "cookie.privacy": "Datenschutzerklärung",
    "cookie.accept": "Verstanden",
    "cookie.more": "Mehr erfahren",

    "buchung.title": "Terminanfrage",
    "buchung.step1": "Leistung wählen",
    "buchung.step2": "Datum & Uhrzeit",
    "buchung.step3": "Deine Daten",
    "buchung.name": "Name *",
    "buchung.firstname": "Vorname *",
    "buchung.lastname": "Nachname *",
    "buchung.email": "E-Mail *",
    "buchung.phone": "Telefon *",
    "buchung.instagram": "Instagram-Handle (optional, z.B. @username)",
    "buchung.verify_note": "Bitte gib echte Kontaktdaten an – wir bestätigen deinen Termin per E-Mail und melden uns telefonisch bei Rückfragen. Erfundene Angaben führen zur Ablehnung der Anfrage.",
    "buchung.err_name": "Bitte gib Vor- und Nachname an (mindestens 2 Buchstaben).",
    "buchung.err_email_invalid": "Bitte gib eine gültige E-Mail-Adresse an.",
    "buchung.err_phone_invalid": "Bitte gib eine gültige Telefonnummer an (7–15 Ziffern).",
    "buchung.err_instagram_invalid": "Instagram-Handle ist ungültig (nur Buchstaben, Zahlen, . und _).",
    "buchung.notes": "Anmerkungen (optional)",
    "buchung.agb_prefix": "Ich habe die",
    "buchung.agb_suffix": "gelesen und akzeptiere sie.",
    "buchung.agb_view": "AGB ansehen",
    "buchung.submit": "Unverbindlich anfragen",
    "buchung.back": "Zurück",
    "buchung.next": "Weiter",
    "buchung.shore_hint": "Lieber sofort verbindlich buchen?",
    "buchung.shore_link": "Über Shore buchen",
    "buchung.shore_direct": "Direkt verbindlich buchen",
    "buchung.total": "Gesamt",
    "buchung.success": "Vielen Dank! Wir melden uns bald.",
    "buchung.multi_hint": "Mehrfachauswahl möglich – kombiniere Leistungen und Add-ons frei.",
    "buchung.date_label": "Datum",
    "buchung.time_label": "Uhrzeit",
    "buchung.hours_hint": "Termine Mo–Fr, 09:00–17:00 Uhr.",
    "buchung.summary": "Übersicht",
    "buchung.selected_services": "Leistungen",
    "buchung.none_selected": "Noch keine ausgewählt",
    "buchung.confirm_note": "Wir bestätigen deinen Termin per E-Mail.",
    "buchung.payment_note": "Zahlung bequem vor Ort mit Karte oder bar.",
    "buchung.notice_title": "Bitte beachten:",
    "buchung.notice_body": "Diese Buchung ist eine unverbindliche Terminanfrage – noch keine feste Buchung. Wir prüfen deinen Wunschtermin und bestätigen ihn per E-Mail. Für eine sofort verbindliche Buchung zahle direkt online über Shore.",
    "buchung.err_service": "Bitte wähle mindestens eine Leistung.",
    "buchung.err_datetime": "Bitte wähle Datum und Uhrzeit.",
    "buchung.err_required": "Bitte fülle alle Pflichtfelder aus.",
    "buchung.err_agb": "Bitte akzeptiere die AGB, um fortzufahren.",
    "buchung.error_generic": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    "buchung.success_title": "Vielen Dank!",
    "buchung.success_body": "Wir haben deine Anfrage erhalten und melden uns per E-Mail.",
    "buchung.success_cta": "Zurück zur Startseite",

    "kontakt.title": "Kontakt",
    "kontakt.hero": "Sag Hallo.",
    "kontakt.subtitle": "Fragen zu Behandlungen, Terminen oder Schulungen? Schreib uns — wir melden uns so schnell wie möglich.",
    "kontakt.name": "Name",
    "kontakt.email": "E-Mail",
    "kontakt.message": "Deine Nachricht",
    "kontakt.send": "Nachricht senden",
    "kontakt.err_required": "Bitte fülle alle Felder aus.",
    "kontakt.err_generic": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    "kontakt.success": "Danke! Deine Nachricht ist bei uns eingegangen.",

    "legal.notice": "Aus rechtlichen Gründen ist der folgende Text nur auf Deutsch verbindlich.",

    "packages.eyebrow": "Pakete",
    "packages.title": "Beauty-Pakete",
    "packages.subtitle": "Vier sorgfältig zusammengestellte Erlebnisse – vom natürlichen Pflege-Programm bis zum eleganten French-Look.",
    "packages.includes": "Inklusive",
    "packages.featured": "Beliebt",
    "packages.book": "Als Paket buchen",

    "pkg.pure.name": "Pure Care",
    "pkg.pure.tag": "Gepflegte Hände und Füße, ganz ohne Farbe.",
    "pkg.pure.body": "Das perfekte Paket für alle, die Wert auf natürliche Schönheit, gesunde Nägel und ein rundum gepflegtes Erscheinungsbild legen. Ideal auch für Männer.",
    "pkg.pure.incl": "Russische Maniküre · Russische Pediküre",

    "pkg.natural.name": "Natural Luxury",
    "pkg.natural.tag": "Natürlich. Zeitlos. Elegant.",
    "pkg.natural.body": "Die perfekte Wahl für alle, die den dezenten Look lieben. Eine stabile Nagelverstärkung in Natur, Milky oder Rosa – kombiniert mit einer gepflegten russischen Pediküre inklusive Shellac.",
    "pkg.natural.incl": "Naturnagelverstärkung · Russische Pediküre inkl. Shellac",

    "pkg.signature.name": "Signature",
    "pkg.signature.tag": "Unser beliebtestes Beauty-Paket.",
    "pkg.signature.body": "Perfekt für alle, die gepflegte Hände und Füße mit einer individuellen Farbe genießen möchten. Ein harmonisches Gesamtbild für jeden Anlass.",
    "pkg.signature.incl": "Naturnagelverstärkung mit Farbe deiner Wahl · Russische Pediküre inkl. Shellac",

    "pkg.elegant.name": "Elegant",
    "pkg.elegant.tag": "Der zeitlose Klassiker für einen stilvollen Auftritt.",
    "pkg.elegant.body": "French Nails stehen für Eleganz und Präzision. Dieses Paket vereint perfekt geformte Nägel mit einer luxuriösen Pediküre im klassischen French-Look.",
    "pkg.elegant.incl": "Naturnagelverstärkung French · Russische Pediküre inkl. French",

    "countdown.days": "Tage",
    "countdown.hours": "Stunden",
    "countdown.minutes": "Minuten",
    "countdown.seconds": "Sekunden",

    "locked.eyebrow": "Terminanfrage",
    "locked.title": "Bald für dich da",
    "locked.body": "Terminanfragen sind erst zum 1. September 2026 freigeschaltet – dem Tag unserer Eröffnung. Wir freuen uns auf euch! 🌿",
    "locked.date": "01.09.2026",
    "locked.back": "Zurück zur Startseite",

    "book.eyebrow": "Termin",
    "book.title": "Direkt buchen oder Warteliste",
    "book.intro": "Alle verfügbaren Termine buchst du direkt über Shore. Ist dein Wunschtermin nicht dabei? Trag dich auf die Warteliste ein und wir melden uns, sobald ein passender Slot frei wird.",
    "book.shore_eyebrow": "Sofort buchbar",
    "book.shore_title": "Freie Termine in Shore ansehen",
    "book.shore_body": "Alle aktuell verfügbaren Zeiten mit Live-Kalender. Bestätigung erfolgt automatisch.",
    "book.shore_cta": "Über Shore buchen",
    "book.wl_eyebrow": "Warteliste",
    "book.wl_title": "Kein passender Termin dabei?",
    "book.wl_body": "Kein Problem – trag deinen Wunsch hier ein. Wir informieren dich, sobald ein neuer Slot verfügbar ist.",
    "book.wl_first": "Vorname *",
    "book.wl_last": "Nachname *",
    "book.wl_email": "E-Mail *",
    "book.wl_phone": "Handynummer *",
    "book.wl_service_placeholder": "Gewünschte Dienstleistung *",
    "book.wl_notes": "Anmerkungen (optional)",
    "book.wl_submit": "Auf Warteliste setzen",
    "book.wl_privacy": "Mit dem Absenden bestätigst du, dass wir deine Daten zur Kontaktaufnahme verwenden dürfen. Details siehe Datenschutz.",
    "book.wl_success_title": "Du stehst auf der Warteliste!",
    "book.wl_success_body": "Wir melden uns, sobald ein passender Termin frei wird. Bis dahin – herzlichen Dank für deine Geduld! 🌿",

    "schulungen.eyebrow": "Schulungen & Academy",
    "schulungen.title": "In Vorbereitung",
    "schulungen.body": "Unsere Schulungen und Workshops zur russischen Nageltechnik sind in Vorbereitung. Trag dich in die Warteliste ein und erfahre als Erste, wann es losgeht.",
    "schulungen.email_placeholder": "Deine E-Mail",
    "schulungen.notify": "Benachrichtigen",
    "schulungen.joined": "Danke — wir melden uns bei dir. ✦",
    "schulungen.success_toast": "Du stehst auf der Warteliste!",
    "schulungen.err_email": "Bitte gib deine E-Mail ein.",
    "schulungen.course_label": "Welche Schulung interessiert dich?",
    "schulungen.course_manikure": "Maniküre-Schulung",
    "schulungen.course_pedikure": "Pediküre-Schulung",
    "schulungen.err_course": "Bitte wähle eine Schulung aus.",
    "schulungen.err_name": "Bitte Vor- und Nachnamen eintragen.",
    "schulungen.err_phone": "Bitte eine gültige Handynummer eintragen.",

    "schulungen.hero_title_a": "Präzise Technik.",
    "schulungen.hero_title_b": "Professionelles Arbeiten.",
    "schulungen.hero_title_c": "Dein nächster Schritt.",
    "schulungen.hero_q": "Du möchtest neu in die Beauty-Branche starten oder deine bestehende Technik perfektionieren?",
    "schulungen.hero_body": "In unseren individuellen 1:1-Schulungen lernst du eine präzise, saubere und professionelle Arbeitsweise – mit viel Praxis, persönlicher Betreuung und einem besonderen Fokus auf perfekte Ergebnisse und Hygiene.",
    "schulungen.cta_courses": "Kurse entdecken",
    "schulungen.cta_apply": "Direkt anfragen",
    "schulungen.courses_eyebrow": "Unsere Schulungen",
    "schulungen.courses_title": "Wähle deine Technik",
    "schulungen.courses_note": "Alle Schulungen finden als persönliche 1:1-Intensivschulung statt – Termine nach Vereinbarung.",
    "schulungen.learn_label": "Das lernst du",
    "schulungen.c_hygiene": "Hygienische Aufbereitung der Instrumente (Reinigung, Desinfektion & Sterilisation)",
    "schulungen.c1_name": "Apparative Maniküre",
    "schulungen.c1_tag": "Russian Manicure · inklusive Gelauftrag",
    "schulungen.c1_price": "899 €",
    "schulungen.c1_desc": "Intensiv-Schulung im 1:1 – an diesem Tag gehörst nur du uns. Wir kümmern uns so intensiv um dich, dass du am nächsten Tag direkt an deinen Kundinnen arbeiten kannst. Für alle, die die apparative Maniküre präzise und professionell erlernen oder ihre Technik perfektionieren möchten.",
    "schulungen.c1_b1": "Professionelle Vorbereitung des Naturnagels",
    "schulungen.c1_b2": "Präzise Nagelhautbearbeitung",
    "schulungen.c1_b3": "Sicherer Umgang mit Fräser & Bits",
    "schulungen.c1_b4": "Naturnagelverstärkung mit Gel & sauberer, kontrollierter Gelauftrag",
    "schulungen.c1_for": "Für Anfängerinnen, Wiedereinsteigerinnen und erfahrene Naildesignerinnen.",
    "schulungen.c1_cta": "Maniküre-Schulung anfragen",
    "schulungen.c2_name": "Apparative Pediküre",
    "schulungen.c2_tag": "Russian Pedicure · inklusive Shellac-Auftrag",
    "schulungen.c2_price": "1.199 €",
    "schulungen.c2_desc": "Intensiv-Schulung im 1:1 – an diesem Tag gehörst nur du uns. Wir kümmern uns so intensiv um dich, dass du am nächsten Tag direkt an deinen Kundinnen arbeiten kannst. Professionelle apparative Pediküre – von der präzisen Nagel- und Nagelhautbearbeitung bis zur gepflegten Fußhaut und dem perfekten Shellac-Finish.",
    "schulungen.c2_b1": "Präzise Nagel- und Nagelhautbearbeitung",
    "schulungen.c2_b2": "Professionelle Hornhautbearbeitung mit Podo-Disk",
    "schulungen.c2_b3": "Schonende Bearbeitung trockener Hautstellen",
    "schulungen.c2_b4": "Sauberer, präziser Shellac-/Gel-Lack-Auftrag",
    "schulungen.c2_for": "Für Anfängerinnen, Wiedereinsteigerinnen, Naildesignerinnen, Kosmetikerinnen und Fachfußpflegerinnen.",
    "schulungen.c2_cta": "Pediküre-Schulung anfragen",
    "schulungen.incl_eyebrow": "Im Preis enthalten",
    "schulungen.incl_title": "Bei jeder Schulung inklusive",
    "schulungen.incl1_title": "1:1 Intensivschulung",
    "schulungen.incl1_body": "Individuelle Betreuung und persönliche Korrektur während der gesamten Schulung.",
    "schulungen.incl2_title": "Starterset",
    "schulungen.incl2_body": "Eine professionelle Grundausstattung, mit der du das Erlernte direkt weiterüben kannst.",
    "schulungen.incl3_title": "2 Zertifikate",
    "schulungen.incl3_body": "Ein Fachzertifikat über deine absolvierte Schulung sowie ein separates Zertifikat über die fachgerechte Aufbereitung und Sterilisation von Instrumenten.",
    "schulungen.incl4_title": "Hygiene & Instrumentenaufbereitung",
    "schulungen.incl4_body": "Professionelle Hygiene und ein strukturierter Aufbereitungsprozess sind feste Bestandteile deiner Schulung.",
    "schulungen.incl5_title": "1 Jahr persönliche Nachbetreuung",
    "schulungen.incl5_body": "Auch nach deiner Schulung bist du nicht auf dich allein gestellt. Bei Fragen zu den vermittelten Techniken kannst du dich innerhalb des ersten Jahres persönlich an uns wenden.",
    "schulungen.philo_title": "Dein Neustart. Deine Technik. Dein Weg.",
    "schulungen.philo_p1": "Uns ist wichtig, dass du nicht nur einzelne Handgriffe lernst, sondern verstehst, was du tust und warum.",
    "schulungen.philo_p2": "Deshalb finden unsere Schulungen ausschließlich im persönlichen 1:1-Format statt. So können wir individuell auf deinen Wissensstand, deine Arbeitsweise und deine Fragen eingehen.",
    "schulungen.philo_p3": "Ob du ganz am Anfang stehst oder deine Technik auf das nächste Level bringen möchtest – wir arbeiten gezielt an deinen Fähigkeiten und deinem persönlichen Fortschritt.",
    "schulungen.closing": "Wissen, Präzision und Qualität, die dich langfristig begleiten.",
    "schulungen.form_eyebrow": "Anfrage",
    "schulungen.form_title": "Sichere dir deinen Schulungsplatz",
    "schulungen.form_body": "Wähle deine Schulung und hinterlasse deine Daten – wir melden uns persönlich bei dir mit Terminvorschlägen.",
    "schulungen.dates_eyebrow": "Termine · Winter 2026",
    "schulungen.dates_title": "Wähle deinen Schulungstag",
    "schulungen.dates_note": "Pro Termin findet genau eine Schulung statt – Maniküre oder Pediküre, mit nur einer Schülerin pro Tag. Ist ein Termin vergeben, ist er nicht mehr buchbar.",
    "schulungen.dates_start": "Start: 9:00 Uhr",
    "schulungen.dates_break": "1–1,5 Stunden Pause inklusive",
    "schulungen.dates_food": "Für Verpflegung ist gesorgt",
    "schulungen.dates_bring_label": "Das bringst du mit",
    "schulungen.dates_bring": "Gute Laune und einen offenen, klaren Kopf für Neues.",
    "schulungen.book_now": "Direkt buchen",
    "schulungen.book_c1": "Maniküre-Schulung buchen",
    "schulungen.book_c2": "Pediküre-Schulung buchen",
    "schulungen.dates_enquire": "Erst unverbindlich anfragen",
    "academy.dialog_title": "Schulung buchen",
    "academy.choose_date": "Wähle deinen Termin",
    "academy.date_taken": "vergeben",
    "academy.payment_label": "Zahlungsoption wählen",
    "academy.pay_full": "Gesamtbetrag",
    "academy.pay_full_note": "Einmalzahlung – alles erledigt",
    "academy.pay_deposit": "Anzahlung · 30 %",
    "academy.pay_deposit_note": "Restbetrag (70 %) bequem online – Zahlungslink kommt 7 Tage vorher per E-Mail",
    "academy.to_checkout": "Weiter zur sicheren Zahlung",
    "academy.secure_note": "Sichere Zahlung über Stripe · Karte, Klarna (auch Raten) u. a. · keine Mehrwertsteuer gemäß § 19 UStG",
    "academy.err_date": "Bitte wähle einen Termin aus.",
    "academy.err_payment": "Bitte wähle eine Zahlungsoption.",
    "academy.err_taken": "Dieser Termin wurde soeben vergeben – bitte wähle einen anderen.",
    "academy.agb_link": "AGB",
    "academy.street": "Straße & Hausnummer *",
    "academy.zip": "PLZ *",
    "academy.city": "Ort *",
    "academy.err_address": "Bitte gib deine vollständige Adresse (Straße, PLZ, Ort) an.",
    "academy.success_title": "Buchung bestätigt",
    "academy.success_body": "Deine Zahlung war erfolgreich – dein Schulungsplatz ist fest reserviert. Du erhältst in Kürze eine Bestätigung per E-Mail. Wir freuen uns auf dich!",
    "academy.success_checking": "Zahlung wird bestätigt …",
    "academy.success_failed": "Die Zahlung konnte nicht bestätigt werden. Bitte schreib uns kurz – wir prüfen das sofort.",
    "academy.cancel_title": "Zahlung abgebrochen",
    "academy.cancel_body": "Kein Problem – es wurde nichts abgebucht und der Termin ist wieder frei.",
    "academy.back": "Zurück zur Academy",
    "schulungen.err_generic": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",

    "faq.eyebrow": "Gut zu wissen",
    "faq.title": "Häufige Fragen",
    "faq.subtitle": "Alles Wichtige rund um deinen Besuch im Atelier — und wenn etwas offen bleibt:",
    "faq.subtitle_cta": "Schreib uns gerne",
    "faq.q1": "Was ist Russische Maniküre?",
    "faq.a1": "Die Russische Maniküre ist eine präzise Trockentechnik: Die Nagelhaut wird mit feinen Fräseraufsätzen millimetergenau bearbeitet und vorsichtig abgeschnitten. Das Ergebnis: ein besonders sauberes Nagelbild, bei dem die Farbe bis ganz an den Nagelrand reicht — und das deutlich länger gepflegt aussieht.",
    "faq.q2": "Wie lange hält die Maniküre?",
    "faq.a2": "In der Regel 2–4 Wochen — bei jeder Kundin ganz individuell. Danach wächst der Naturnagel sichtbar heraus — dann empfehlen wir eine neue Modellage.",
    "faq.q3": "Tut die Behandlung weh?",
    "faq.a3": "Nein. Die Technik ist sehr schonend, und wir arbeiten mit ruhiger Hand und viel Gefühl. Die meisten Kundinnen empfinden den Termin sogar als kleine, entspannende Auszeit.",
    "faq.q4": "Wie wird im Studio hygienisch gearbeitet?",
    "faq.a4": "Hygiene hat bei uns höchste Priorität: Alle Instrumente werden nach jedem Termin desinfiziert und sterilisiert, Einwegmaterialien kommen pro Kundin nur ein einziges Mal zum Einsatz. „Wo Hygiene auf Ästhetik trifft“ ist bei uns gelebter Alltag.",
    "faq.q5": "Wie lange dauert ein Termin?",
    "faq.a5": "Je nach Leistung zwischen ca. 30 und 150 Minuten. Eine Russische Maniküre dauert etwa 30 Minuten, eine Verstärkung mit Farbe etwas länger — wir nehmen uns bewusst Zeit für jedes Detail.",
    "faq.q6": "Wie kann ich bezahlen?",
    "faq.a6": "Ganz bequem vor Ort — mit Karte oder bar.",
    "faq.q7": "Kann ich meinen Termin verschieben oder absagen?",
    "faq.a7": "Ja, selbstverständlich — bis 48 Stunden vor deinem Termin kostenfrei. Schreib uns einfach kurz, dann finden wir gemeinsam einen neuen Termin.",
    "faq.q8": "Ist die Maniküre auch für Männer geeignet?",
    "faq.a8": "Auf jeden Fall! Gepflegte Hände sind zeitlos — die Russische Maniküre ohne Farbe ist ideal für alle, die sich natürliche, gepflegte Nägel wünschen.",
  },

  en: {
    "nav.buchung": "Book",
    "nav.schulungen": "Training",
    "nav.academy": "Academy",
    "portal.eyebrow": "Students only",
    "portal.title": "Academy · Student area",
    "portal.lock_body": "This area is for students of Maschas Atelier Academy only. You will receive your personal access code automatically by e-mail on your course day at midnight.",
    "portal.code_placeholder": "Access code",
    "portal.unlock": "Unlock",
    "portal.err_code": "This code is not correct.",
    "portal.welcome": "Welcome to the Academy area",
    "portal.hello": "Hello {name} – great to see you!",
    "portal.err_not_yet": "Your access will be activated on {date} at midnight. We look forward to seeing you!",
    "portal.err_expired": "Your access has expired – it was valid for one year from your course day. Feel free to contact the studio if you have any questions.",
    "portal.body": "Here you will find the schedule of your course, everything that is included, and your course materials to download.",
    "portal.sec_ablauf": "Your course schedule",
    "portal.ablauf_t1": "Theory: Instrument reprocessing & sterilisation",
    "portal.ablauf_d1": "Cleaning, disinfection and sterilisation – the way we work in our studio and as required in Rhineland-Palatinate.",
    "portal.ablauf_t2": "Theory: Anatomy of the nail",
    "portal.ablauf_d2": "Structure, growth and characteristics of the natural nail. Both theory blocks take about 2 hours in total.",
    "portal.ablauf_t3": "Break together",
    "portal.ablauf_d3": "1 to 1.5 hours – food and drinks are provided.",
    "portal.ablauf_t4": "Practice: Working on the customer / model",
    "portal.ablauf_d4": "Nail preparation followed by the colour or gel application – step by step, together.",
    "portal.sec_inklusive": "Included in your course",
    "portal.inkl_1": "1:1 intensive coaching",
    "portal.inkl_2": "Starter kit with working materials",
    "portal.inkl_3": "Two certificates (handed over personally on the course day)",
    "portal.inkl_4": "Food & a generous break (1–1.5 hours)",
    "portal.inkl_5": "One year of follow-up support",
    "portal.inkl_6": "All course materials as PDF",
    "portal.sec_materialien": "Course materials",
    "portal.materialien_hint": "All materials are available as PDF downloads from your course day onwards.",
    "portal.m_sterilisation": "Reprocessing & sterilisation of manicure/pedicure instruments",
    "portal.m_anatomie": "Anatomy of the nail",
    "portal.m_vorbereitung": "Nail preparation",
    "portal.m_farbauftrag": "Colour & gel application",
    "portal.sec_zertifikate": "Your certificates",
    "portal.zert_body": "At the end of the course you will receive two certificates. We hand both over to you personally – they are not available for download:",
    "portal.zert_1": "Certificate „Instrument reprocessing & sterilisation“ – according to the standard we practise in our studio and which is mandatory in Rhineland-Palatinate.",
    "portal.zert_2": "Certificate for the successfully completed course (manicure or pedicure).",
    "portal.empty": "Materials will be added here shortly.",
    "portal.lock_again": "Lock this area again",
    "nav.kontakt": "Contact",
    "nav.buchen_cta": "Book appointment",
    "nav.terminanfrage": "Request appointment",

    "hero.tagline": "Where hygiene meets aesthetics.",
    "hero.tagline_opening": "Grand opening on 01/09/2026.",
    "hero.title_a": "Russian",
    "hero.title_b": "Manicure",
    "hero.subtitle": "Timeless nail design & precise care. Studio & Academy in Koblenz.",
    "hero.cta_book": "Request appointment",
    "hero.cta_services": "View services",
    "hero.cta_academy": "Book a course",

    "about.eyebrow": "About us",
    "about.title": "Beauty in the detail — with calm and care.",
    "about.body": "Maschas Atelier is a place for anyone who values precision and care. We combine the Russian nail technique with a minimalist, calm atmosphere — so every appointment feels like a small time-out. Soon with additional cosmetic treatments too.",
    "about.ch1_title": "Russian Manicure",
    "about.ch1_text": "Millimetre-precise cuticle work for a flawless, long-lasting result.",
    "about.ch2_title": "Russian Pedicure",
    "about.ch2_text": "Including callus care, peel and finishing care — for polished, relaxed feet.",
    "about.ch3_title": "Training & Academy",
    "about.ch3_text": "Passing on knowledge: courses and workshops coming soon.",

    "svc.from": "From",
    "svc.manikure_title": "Russian Manicure",
    "svc.pedikure_title": "Russian Pedicure",
    "svc.schulungen_title": "Training & Academy",
    "svc.soon": "Enquire now",

    "prices.eyebrow": "Price list",
    "prices.title": "Services & prices",
    "prices.cta": "Book appointment",
    "prices.grp_manikure": "Manicure",
    "prices.grp_pedikure": "Pedicure",
    "prices.grp_addons": "Add-ons",
    "prices.grp_manikure_note": "All manicures include Russian manicure (cuticle care).",
    "prices.grp_pedikure_note": "All pedicures include callus care, peel and finishing care.",
    "prices.duration_manikure": "approx. 75 min",
    "prices.duration_pedikure": "approx. 60 min",
    "prices.duration_optional": "optional",

    "item.russ_manikure": "Russian manicure",
    "item.russ_manikure_desc": "Perfect if you want your natural nails more groomed – also ideal for men.",
    "item.nail_extension_natural": "Nail extension natural/milky/pink",
    "item.nail_extension_color": "Nail extension incl. colour",
    "item.nail_extension_french": "Nail extension incl. French",
    "item.russ_pedikure": "Russian pedicure",
    "item.russ_pedikure_nude": "Russian pedicure incl. nude/pink base",
    "item.russ_pedikure_shellac": "Russian pedicure incl. Shellac",
    "item.russ_pedikure_french": "Russian pedicure incl. French",
    "item.removal": "Nail removal",
    "item.chrome": "Chrome pigment",
    "item.french_per_nail": "French per nail",
    "item.polkadot_full": "Polkadot full cover",
    "item.polkadot_french": "Polkadot on French per nail",
    "item.full_french_set": "10 fingers or 10 toes French",

    "hours.eyebrow": "Opening hours",
    "hours.title": "Here for you",
    "hours.cta": "Request appointment",
    "hours.days_short": "Mon – Fri",
    "hours.time": "09:00 – 17:00",
    "hours.payment_label": "Payment options",
    "hours.payment_body": "Pay conveniently on site by ",
    "hours.payment_body_strong": "card or cash",
    "hours.cta_eyebrow": "Your appointment",
    "hours.cta_title": "Ready for beautiful nails?",
    "hours.cta_body": "Send us your non-binding request — we'll confirm your appointment by email. For an instantly confirmed booking you can pay online via Shore.",
    "hours.cta_button": "Book appointment now",

    "day.mo": "Monday",
    "day.di": "Tuesday",
    "day.mi": "Wednesday",
    "day.do": "Thursday",
    "day.fr": "Friday",
    "day.sa": "Saturday",
    "day.so": "Sunday",
    "day.closed": "Closed",

    "team.eyebrow": "The atelier is growing",
    "team.title": "Our team",
    "team.body": "Every treatment is delivered with care, experience and passion. Soon we will welcome more nail designers — meaning more slots for you at the same quality.",
    "team.hiring_eyebrow": "We're hiring",
    "team.hiring_title": "Your place?",
    "team.hiring_body": "Do you love precision, hygiene and the little details that make beauty – be it on nails, lashes, brows or skin? Then join our atelier.",
    "team.hiring_cta": "Apply now →",

    "portfolio.eyebrow": "@maschasatelier",
    "portfolio.title": "Portfolio",
    "portfolio.body": "Recent work from the atelier — tap an image to view larger.",
    "portfolio.follow": "Follow on Instagram",

    "beforeafter.eyebrow": "Before / After",
    "beforeafter.title": "Craft made visible",
    "beforeafter.body": "Drag the slider — from raw to flawless.",

    "reviews.eyebrow": "Reviews",
    "reviews.title": "What clients say",
    "reviews.write": "Write a review",
    "reviews.on_google": "Review on Google",
    "reviews.name": "Your name",
    "reviews.text": "Your experience…",
    "reviews.submit": "Publish review",
    "reviews.photos": "Add photos",

    "social.eyebrow": "Google reviews",
    "social.title": "What clients say",
    "social.placeholder": "Google link coming soon",

    "location.eyebrow": "How to find us",
    "location.title": "Directions & location",
    "location.route": "Get directions",
    "location.note": "Easy walk from Koblenz city center. Parking available nearby.",
    "location.consent_title": "Map hidden",
    "location.consent_body": "Loading the map transmits data (incl. your IP address) to Google. See privacy notice for details.",
    "location.consent_cta": "Load map",

    "hours.eyebrow": "Opening hours",
    "hours.title": "Here for you",
    "hours.cta": "Request appointment",
    "hours.days_short": "Mon – Fri",
    "hours.time": "09:00 – 17:00",

    "footer.contact": "Contact",
    "footer.hours": "Hours",
    "footer.social": "Social",
    "footer.legal": "Legal",

    "cookie.title": "Cookies & privacy",
    "cookie.body": "We only use technically necessary cookies so our site works. No tracking, no analytics. Details in our",
    "cookie.privacy": "privacy policy",
    "cookie.accept": "Got it",
    "cookie.more": "Learn more",

    "buchung.title": "Appointment request",
    "buchung.step1": "Choose service",
    "buchung.step2": "Date & time",
    "buchung.step3": "Your details",
    "buchung.name": "Name *",
    "buchung.firstname": "First name *",
    "buchung.lastname": "Last name *",
    "buchung.email": "Email *",
    "buchung.phone": "Phone *",
    "buchung.instagram": "Instagram handle (optional, e.g. @username)",
    "buchung.verify_note": "Please provide real contact details – we confirm your appointment by email and call for questions. Fake information leads to your request being declined.",
    "buchung.err_name": "Please enter both first and last name (at least 2 letters).",
    "buchung.err_email_invalid": "Please enter a valid email address.",
    "buchung.err_phone_invalid": "Please enter a valid phone number (7–15 digits).",
    "buchung.err_instagram_invalid": "Instagram handle is invalid (letters, numbers, . and _ only).",
    "buchung.notes": "Notes (optional)",
    "buchung.agb_prefix": "I have read and accept the",
    "buchung.agb_suffix": ".",
    "buchung.agb_view": "View terms",
    "buchung.submit": "Send non-binding request",
    "buchung.back": "Back",
    "buchung.next": "Next",
    "buchung.shore_hint": "Prefer to book directly?",
    "buchung.shore_link": "Book via Shore",
    "buchung.shore_direct": "Book directly & bindingly",
    "buchung.total": "Total",
    "buchung.success": "Thank you! We'll be in touch soon.",
    "buchung.multi_hint": "Multiple selection possible – combine services and add-ons freely.",
    "buchung.date_label": "Date",
    "buchung.time_label": "Time",
    "buchung.hours_hint": "Appointments Mon–Fri, 09:00–17:00.",
    "buchung.summary": "Summary",
    "buchung.selected_services": "Services",
    "buchung.none_selected": "Nothing selected yet",
    "buchung.confirm_note": "We'll confirm your appointment by email.",
    "buchung.payment_note": "Pay conveniently on site by card or cash.",
    "buchung.notice_title": "Please note:",
    "buchung.notice_body": "This booking is a non-binding appointment request – not yet a confirmed booking. We'll review your requested date and confirm by email. For an instantly confirmed booking pay online via Shore.",
    "buchung.err_service": "Please select at least one service.",
    "buchung.err_datetime": "Please select a date and time.",
    "buchung.err_required": "Please fill in all required fields.",
    "buchung.err_agb": "Please accept the terms to continue.",
    "buchung.error_generic": "Something went wrong. Please try again.",
    "buchung.success_title": "Thank you!",
    "buchung.success_body": "We received your request and will reply by email.",
    "buchung.success_cta": "Back to homepage",

    "kontakt.title": "Contact",
    "kontakt.hero": "Say hello.",
    "kontakt.subtitle": "Questions about treatments, appointments or training? Send us a message — we'll get back to you as soon as we can.",
    "kontakt.name": "Name",
    "kontakt.email": "Email",
    "kontakt.message": "Your message",
    "kontakt.send": "Send message",
    "kontakt.err_required": "Please fill in all fields.",
    "kontakt.err_generic": "Something went wrong. Please try again.",
    "kontakt.success": "Thanks! Your message has been received.",

    "legal.notice": "For legal reasons the following text is binding only in German.",

    "packages.eyebrow": "Packages",
    "packages.title": "Beauty packages",
    "packages.subtitle": "Four carefully curated experiences – from natural care to the classic French look.",
    "packages.includes": "Includes",
    "packages.featured": "Popular",
    "packages.book": "Book as package",

    "pkg.pure.name": "Pure Care",
    "pkg.pure.tag": "Polished hands and feet – entirely colour-free.",
    "pkg.pure.body": "The perfect package for anyone who values natural beauty, healthy nails and an all-around groomed look. Also ideal for men.",
    "pkg.pure.incl": "Russian manicure · Russian pedicure",

    "pkg.natural.name": "Natural Luxury",
    "pkg.natural.tag": "Natural. Timeless. Elegant.",
    "pkg.natural.body": "The perfect choice if you love the subtle look. A durable nail extension in natural, milky or pink – combined with a groomed Russian pedicure incl. Shellac.",
    "pkg.natural.incl": "Natural nail extension · Russian pedicure incl. Shellac",

    "pkg.signature.name": "Signature",
    "pkg.signature.tag": "Our most-loved beauty package.",
    "pkg.signature.body": "Perfect for those who want polished hands and feet in a colour of their choice. A harmonious look for every occasion.",
    "pkg.signature.incl": "Nail extension in the colour of your choice · Russian pedicure incl. Shellac",

    "pkg.elegant.name": "Elegant",
    "pkg.elegant.tag": "The timeless classic for a refined appearance.",
    "pkg.elegant.body": "French nails stand for elegance and precision. This package combines perfectly shaped nails with a luxurious pedicure in the classic French look.",
    "pkg.elegant.incl": "French nail extension · Russian pedicure incl. French",

    "countdown.days": "Days",
    "countdown.hours": "Hours",
    "countdown.minutes": "Minutes",
    "countdown.seconds": "Seconds",

    "locked.eyebrow": "Booking",
    "locked.title": "Coming soon",
    "locked.body": "Appointment requests will open on September 1st, 2026 — our launch day. We can't wait to welcome you! 🌿",
    "locked.date": "01.09.2026",
    "locked.back": "Back to homepage",

    "book.eyebrow": "Appointments",
    "book.title": "Book directly or join the waiting list",
    "book.intro": "Book any available slot directly via Shore. Your preferred time isn't listed? Add yourself to the waiting list and we'll get in touch once a matching slot opens.",
    "book.shore_eyebrow": "Instant booking",
    "book.shore_title": "See free slots on Shore",
    "book.shore_body": "Live calendar with all currently available times. Instant confirmation.",
    "book.shore_cta": "Book via Shore",
    "book.wl_eyebrow": "Waiting list",
    "book.wl_title": "No matching slot?",
    "book.wl_body": "No worries — leave your details here and we'll notify you as soon as a spot opens.",
    "book.wl_first": "First name *",
    "book.wl_last": "Last name *",
    "book.wl_email": "Email *",
    "book.wl_phone": "Mobile number *",
    "book.wl_service_placeholder": "Desired service *",
    "book.wl_notes": "Notes (optional)",
    "book.wl_submit": "Join waiting list",
    "book.wl_privacy": "By submitting you allow us to contact you. See privacy policy for details.",
    "book.wl_success_title": "You're on the waiting list!",
    "book.wl_success_body": "We'll get in touch as soon as a matching slot opens. Thank you for your patience! 🌿",

    "schulungen.eyebrow": "Training & Academy",
    "schulungen.title": "Coming soon",
    "schulungen.body": "Our courses and workshops on the Russian nail technique are in preparation. Join the waiting list and be the first to know when we launch.",
    "schulungen.email_placeholder": "Your email",
    "schulungen.notify": "Notify me",
    "schulungen.joined": "Thanks — we'll be in touch. ✦",
    "schulungen.success_toast": "You're on the waiting list!",
    "schulungen.err_email": "Please enter your email.",
    "schulungen.course_label": "Which course are you interested in?",
    "schulungen.course_manikure": "Manicure course",
    "schulungen.course_pedikure": "Pedicure course",
    "schulungen.err_course": "Please choose a course.",
    "schulungen.err_name": "Please enter your first and last name.",
    "schulungen.err_phone": "Please enter a valid mobile number.",

    "schulungen.hero_title_a": "Precise technique.",
    "schulungen.hero_title_b": "Professional work.",
    "schulungen.hero_title_c": "Your next step.",
    "schulungen.hero_q": "Looking to start fresh in the beauty industry or perfect your existing technique?",
    "schulungen.hero_body": "In our individual 1:1 courses you will learn a precise, clean and professional way of working — with plenty of practice, personal guidance and a special focus on perfect results and hygiene.",
    "schulungen.cta_courses": "Explore courses",
    "schulungen.cta_apply": "Enquire now",
    "schulungen.courses_eyebrow": "Our courses",
    "schulungen.courses_title": "Choose your technique",
    "schulungen.courses_note": "All courses take place as personal 1:1 intensive training — dates by arrangement.",
    "schulungen.learn_label": "What you will learn",
    "schulungen.c_hygiene": "Hygienic reprocessing of instruments (cleaning, disinfection & sterilisation)",
    "schulungen.c1_name": "E-file manicure",
    "schulungen.c1_tag": "Russian Manicure · incl. gel application",
    "schulungen.c1_price": "899 €",
    "schulungen.c1_desc": "An intensive 1:1 course – this day is all yours. We take such dedicated care of you that you can start working on your own clients the very next day. For everyone who wants to learn e-file manicure precisely and professionally or perfect their technique.",
    "schulungen.c1_b1": "Professional preparation of the natural nail",
    "schulungen.c1_b2": "Precise cuticle work",
    "schulungen.c1_b3": "Safe handling of e-file and bits",
    "schulungen.c1_b4": "Natural nail strengthening with gel & clean, controlled gel application",
    "schulungen.c1_for": "For beginners, returners and experienced nail designers.",
    "schulungen.c1_cta": "Enquire about the manicure course",
    "schulungen.c2_name": "E-file pedicure",
    "schulungen.c2_tag": "Russian Pedicure · incl. Shellac application",
    "schulungen.c2_price": "1.199 €",
    "schulungen.c2_desc": "An intensive 1:1 course – this day is all yours. We take such dedicated care of you that you can start working on your own clients the very next day. Professional e-file pedicure – from precise nail and cuticle work to well-groomed skin and the perfect Shellac finish.",
    "schulungen.c2_b1": "Precise nail and cuticle work",
    "schulungen.c2_b2": "Professional callus treatment with the podo disc",
    "schulungen.c2_b3": "Gentle treatment of dry skin areas",
    "schulungen.c2_b4": "Clean, precise Shellac/gel polish application",
    "schulungen.c2_for": "For beginners, returners, nail designers, beauticians and foot care professionals.",
    "schulungen.c2_cta": "Enquire about the pedicure course",
    "schulungen.incl_eyebrow": "Included in the price",
    "schulungen.incl_title": "Every course includes",
    "schulungen.incl1_title": "1:1 intensive training",
    "schulungen.incl1_body": "Individual guidance and personal correction throughout the entire course.",
    "schulungen.incl2_title": "Starter kit",
    "schulungen.incl2_body": "A professional basic kit so you can keep practising what you have learned right away.",
    "schulungen.incl3_title": "2 certificates",
    "schulungen.incl3_body": "A specialist certificate for your completed course plus a separate certificate on the proper reprocessing and sterilisation of instruments.",
    "schulungen.incl4_title": "Hygiene & instrument reprocessing",
    "schulungen.incl4_body": "Professional hygiene and a structured reprocessing process are integral parts of your course.",
    "schulungen.incl5_title": "1 year of personal follow-up",
    "schulungen.incl5_body": "You are not on your own after your course. If you have questions about the techniques taught, you can contact us personally within the first year.",
    "schulungen.philo_title": "Your fresh start. Your technique. Your way.",
    "schulungen.philo_p1": "It matters to us that you don't just learn individual moves, but understand what you are doing and why.",
    "schulungen.philo_p2": "That is why our courses take place exclusively in a personal 1:1 format. This allows us to respond individually to your level of knowledge, your way of working and your questions.",
    "schulungen.philo_p3": "Whether you are starting from scratch or want to take your technique to the next level — we work specifically on your skills and your personal progress.",
    "schulungen.closing": "Knowledge, precision and quality that stay with you for the long term.",
    "schulungen.form_eyebrow": "Enquiry",
    "schulungen.form_title": "Secure your course spot",
    "schulungen.form_body": "Choose your course and leave your details — we will get in touch personally with date suggestions.",
    "schulungen.dates_eyebrow": "Dates · Winter 2026",
    "schulungen.dates_title": "Choose your course day",
    "schulungen.dates_note": "Each date hosts exactly one course — manicure or pedicure, with only one student per day. Once a date is taken, it can no longer be booked.",
    "schulungen.dates_start": "Start: 9:00 am",
    "schulungen.dates_break": "1–1.5 hour break included",
    "schulungen.dates_food": "Food and drinks provided",
    "schulungen.dates_bring_label": "What to bring",
    "schulungen.dates_bring": "A good mood and an open, clear mind for new things.",
    "schulungen.book_now": "Book now",
    "schulungen.book_c1": "Book the manicure course",
    "schulungen.book_c2": "Book the pedicure course",
    "schulungen.dates_enquire": "Prefer to enquire first",
    "academy.dialog_title": "Book your course",
    "academy.choose_date": "Choose your date",
    "academy.date_taken": "taken",
    "academy.payment_label": "Choose a payment option",
    "academy.pay_full": "Full amount",
    "academy.pay_full_note": "One-time payment – all done",
    "academy.pay_deposit": "Deposit · 30%",
    "academy.pay_deposit_note": "Remaining 70% conveniently online – payment link arrives by e-mail 7 days before",
    "academy.to_checkout": "Continue to secure payment",
    "academy.secure_note": "Secure payment via Stripe · no VAT according to § 19 UStG (small business)",
    "academy.err_date": "Please choose a date.",
    "academy.err_payment": "Please choose a payment option.",
    "academy.err_taken": "This date has just been taken — please choose another one.",
    "academy.agb_link": "terms",
    "academy.street": "Street & number *",
    "academy.zip": "Postcode *",
    "academy.city": "City *",
    "academy.err_address": "Please enter your full address (street, postcode, city).",
    "academy.success_title": "Booking confirmed",
    "academy.success_body": "Your payment was successful – your course spot is firmly reserved. You will receive a confirmation email shortly. We look forward to meeting you!",
    "academy.success_checking": "Confirming your payment …",
    "academy.success_failed": "Your payment could not be confirmed. Please message us — we will check right away.",
    "academy.cancel_title": "Payment cancelled",
    "academy.cancel_body": "No worries – nothing was charged and the date is available again.",
    "academy.back": "Back to the Academy",
    "schulungen.err_generic": "Something went wrong. Please try again.",

    "faq.eyebrow": "Good to know",
    "faq.title": "Frequently asked questions",
    "faq.subtitle": "Everything you need to know about your visit to the studio — and if anything remains open:",
    "faq.subtitle_cta": "Feel free to message us",
    "faq.q1": "What is a Russian manicure?",
    "faq.a1": "The Russian manicure is a precise dry technique: the cuticle is refined millimetre by millimetre with fine e-file bits and carefully trimmed. The result is an exceptionally clean nail bed, so colour reaches right to the edge — and your nails look groomed for much longer.",
    "faq.q2": "How long does the manicure last?",
    "faq.a2": "Usually 2–4 weeks — it is individual for every client. After that, the natural nail visibly grows out, and we recommend a fresh set.",
    "faq.q3": "Does the treatment hurt?",
    "faq.a3": "No. The technique is very gentle, and we work with a calm and careful hand. Most clients even experience their appointment as a small, relaxing break.",
    "faq.q4": "How do you handle hygiene in the studio?",
    "faq.a4": "Hygiene is our top priority: all instruments are disinfected and sterilised after every appointment, and single-use materials are used only once per client. “Where hygiene meets aesthetics” is our everyday practice.",
    "faq.q5": "How long does an appointment take?",
    "faq.a5": "Depending on the service, roughly 30 to 150 minutes. A Russian manicure takes about 30 minutes; extensions with colour take a little longer — we deliberately take time for every detail.",
    "faq.q6": "How can I pay?",
    "faq.a6": "Easily on site — by card or cash.",
    "faq.q7": "Can I reschedule or cancel my appointment?",
    "faq.a7": "Yes, of course — free of charge up to 48 hours before your appointment. Just send us a quick message and we will find a new time together.",
    "faq.q8": "Is the manicure suitable for men too?",
    "faq.a8": "Absolutely! Well-groomed hands are timeless — the Russian manicure without polish is ideal for anyone who wants natural, tidy nails.",
  },

  ru: {
    "nav.buchung": "Запись",
    "nav.schulungen": "Обучение",
    "nav.academy": "Академия",
    "portal.eyebrow": "Только для учениц",
    "portal.title": "Academy · Закрытый раздел",
    "portal.lock_body": "Этот раздел только для учениц Maschas Atelier Academy. Твой персональный код доступа автоматически придёт по e-mail в день курса в 0:00.",
    "portal.code_placeholder": "Код доступа",
    "portal.unlock": "Открыть",
    "portal.err_code": "К сожалению, код неверный.",
    "portal.welcome": "Добро пожаловать в раздел Academy",
    "portal.hello": "Здравствуй, {name} – рады тебя видеть!",
    "portal.err_not_yet": "Твой доступ будет активирован {date} в 0:00. Ждём тебя!",
    "portal.err_expired": "Твой доступ истёк – он действовал один год со дня курса. По вопросам обращайся в студию.",
    "portal.body": "Здесь ты найдёшь план курса, всё, что включено, и учебные материалы для скачивания.",
    "portal.sec_ablauf": "План твоего курса",
    "portal.ablauf_t1": "Теория: Обработка и стерилизация инструментов",
    "portal.ablauf_d1": "Очистка, дезинфекция и стерилизация – как мы работаем в студии и как это предписано в земле Рейнланд-Пфальц.",
    "portal.ablauf_t2": "Теория: Анатомия ногтя",
    "portal.ablauf_d2": "Строение, рост и особенности натурального ногтя. Оба теоретических блока занимают около 2 часов.",
    "portal.ablauf_t3": "Общий перерыв",
    "portal.ablauf_d3": "1–1,5 часа – еда и напитки включены.",
    "portal.ablauf_t4": "Практика: работа на клиентке / модели",
    "portal.ablauf_d4": "Подготовка ногтя, затем цветное или гелевое покрытие – шаг за шагом вместе.",
    "portal.sec_inklusive": "Что включено в курс",
    "portal.inkl_1": "Индивидуальное интенсивное сопровождение 1:1",
    "portal.inkl_2": "Стартовый набор с рабочими материалами",
    "portal.inkl_3": "Два сертификата (личное вручение в день курса)",
    "portal.inkl_4": "Питание и полноценный перерыв (1–1,5 часа)",
    "portal.inkl_5": "Год сопровождения после курса",
    "portal.inkl_6": "Все учебные материалы в PDF",
    "portal.sec_materialien": "Учебные материалы",
    "portal.materialien_hint": "Все материалы доступны для скачивания в PDF со дня курса.",
    "portal.m_sterilisation": "Обработка и стерилизация маникюрных/педикюрных инструментов",
    "portal.m_anatomie": "Анатомия ногтя",
    "portal.m_vorbereitung": "Подготовка ногтя",
    "portal.m_farbauftrag": "Цветное и гелевое покрытие",
    "portal.sec_zertifikate": "Твои сертификаты",
    "portal.zert_body": "В конце курса ты получишь два сертификата. Мы вручаем их лично – для скачивания они недоступны:",
    "portal.zert_1": "Сертификат «Обработка и стерилизация инструментов» – по стандарту нашей студии, обязательному в земле Рейнланд-Пфальц.",
    "portal.zert_2": "Сертификат об успешном прохождении курса (маникюр или педикюр).",
    "portal.empty": "Материалы скоро появятся здесь.",
    "portal.lock_again": "Снова закрыть раздел",
    "nav.kontakt": "Контакт",
    "nav.buchen_cta": "Записаться",
    "nav.terminanfrage": "Заявка на приём",

    "hero.tagline": "Где гигиена встречается с эстетикой.",
    "hero.tagline_opening": "Открытие 01.09.2026.",
    "hero.title_a": "Русский",
    "hero.title_b": "Маникюр",
    "hero.subtitle": "Вневременной дизайн ногтей и точный уход. Студия и академия в Кобленце.",
    "hero.cta_book": "Заявка на приём",
    "hero.cta_services": "Смотреть услуги",
    "hero.cta_academy": "Записаться на курс",

    "about.eyebrow": "О нас",
    "about.title": "Красота в деталях — со спокойствием и вниманием.",
    "about.body": "Maschas Atelier — место для тех, кто ценит точность и уход. Мы сочетаем русскую технику маникюра с минималистичной, спокойной атмосферой — чтобы каждый визит ощущался как маленькая пауза для себя. Скоро — и другие косметические процедуры.",
    "about.ch1_title": "Русский маникюр",
    "about.ch1_text": "Ювелирная работа с кутикулой для безупречного и долговечного результата.",
    "about.ch2_title": "Русский педикюр",
    "about.ch2_text": "С уходом за огрубевшей кожей, пилингом и завершающим уходом — для ухоженных, отдохнувших ног.",
    "about.ch3_title": "Обучение и академия",
    "about.ch3_text": "Делюсь знаниями: курсы и мастер-классы уже совсем скоро.",

    "svc.from": "От",
    "svc.manikure_title": "Русский маникюр",
    "svc.pedikure_title": "Русский педикюр",
    "svc.schulungen_title": "Обучение и академия",
    "svc.soon": "Оставить заявку",

    "prices.eyebrow": "Прайс-лист",
    "prices.title": "Услуги и цены",
    "prices.cta": "Записаться",
    "prices.grp_manikure": "Маникюр",
    "prices.grp_pedikure": "Педикюр",
    "prices.grp_addons": "Дополнительно",
    "prices.grp_manikure_note": "Все виды маникюра включают русский маникюр (обработку кутикулы).",
    "prices.grp_pedikure_note": "Все виды педикюра включают уход за огрубевшей кожей, пилинг и завершающий уход.",
    "prices.duration_manikure": "≈ 75 мин",
    "prices.duration_pedikure": "≈ 60 мин",
    "prices.duration_optional": "по желанию",

    "item.russ_manikure": "Русский маникюр",
    "item.russ_manikure_desc": "Идеально, если хочется просто ухоженные натуральные ногти — например, для мужчин.",
    "item.nail_extension_natural": "Наращивание натуральный / молочный / розовый",
    "item.nail_extension_color": "Наращивание с покрытием цветом",
    "item.nail_extension_french": "Наращивание с френчем",
    "item.russ_pedikure": "Русский педикюр",
    "item.russ_pedikure_nude": "Русский педикюр с нюд/розовой базой",
    "item.russ_pedikure_shellac": "Русский педикюр с Shellac",
    "item.russ_pedikure_french": "Русский педикюр с френчем",
    "item.removal": "Снятие покрытия / наращивания",
    "item.chrome": "Хром-пигмент",
    "item.french_per_nail": "Френч (за ноготь)",
    "item.polkadot_full": "Polkadot полное покрытие",
    "item.polkadot_french": "Polkadot на френче (за ноготь)",

    "hours.eyebrow": "Часы работы",
    "hours.title": "Мы рядом",
    "hours.cta": "Записаться",
    "hours.days_short": "Пн – Пт",
    "hours.time": "09:00 – 17:00",
    "hours.payment_label": "Оплата",
    "hours.payment_body": "Оплата удобно на месте — ",
    "hours.payment_body_strong": "картой или наличными",
    "hours.cta_eyebrow": "Твой визит",
    "hours.cta_title": "Готова к красивым ногтям?",
    "hours.cta_body": "Отправь заявку без обязательств — мы подтвердим приём по email. Для сразу гарантированной записи ты можешь оплатить онлайн через Shore.",
    "hours.cta_button": "Записаться сейчас",

    "day.mo": "Понедельник",
    "day.di": "Вторник",
    "day.mi": "Среда",
    "day.do": "Четверг",
    "day.fr": "Пятница",
    "day.sa": "Суббота",
    "day.so": "Воскресенье",
    "day.closed": "Закрыто",

    "team.eyebrow": "Ателье растёт",
    "team.title": "Наша команда",
    "team.body": "За каждой процедурой — забота, опыт и страсть. Скоро к нам присоединятся новые мастерицы — а значит, больше свободных мест при том же качестве.",
    "team.hiring_eyebrow": "Ищем усиление",
    "team.hiring_title": "Твоё место?",
    "team.hiring_body": "Ты любишь точность, гигиену и мелкие детали, из которых складывается красота — на ногтях, ресницах, бровях или коже? Стань частью нашего ателье.",
    "team.hiring_cta": "Откликнуться →",

    "portfolio.eyebrow": "@maschasatelier",
    "portfolio.title": "Портфолио",
    "portfolio.body": "Свежие работы из ателье — коснись изображения, чтобы увеличить.",
    "portfolio.follow": "Подписаться в Instagram",

    "beforeafter.eyebrow": "До / После",
    "beforeafter.title": "Мастерство на виду",
    "beforeafter.body": "Потяни ползунок — от необработанного к безупречному.",

    "reviews.eyebrow": "Отзывы",
    "reviews.title": "Что говорят клиентки",
    "reviews.write": "Оставить отзыв",
    "reviews.on_google": "Отзыв в Google",
    "reviews.name": "Твоё имя",
    "reviews.text": "Твой опыт…",
    "reviews.submit": "Опубликовать отзыв",
    "reviews.photos": "Добавить фото",

    "social.eyebrow": "Google отзывы",
    "social.title": "Что говорят клиентки",
    "social.placeholder": "Ссылка Google скоро",

    "location.eyebrow": "Как нас найти",
    "location.title": "Как добраться",
    "location.route": "Построить маршрут",
    "location.note": "Легко дойти пешком от центра Кобленца. Парковка рядом.",
    "location.consent_title": "Карта скрыта",
    "location.consent_body": "При загрузке карты данные (в т.ч. твой IP-адрес) передаются в Google. Подробности — в политике конфиденциальности.",
    "location.consent_cta": "Загрузить карту",

    "hours.eyebrow": "Часы работы",
    "hours.title": "Мы рядом",
    "hours.cta": "Записаться",
    "hours.days_short": "Пн – Пт",
    "hours.time": "09:00 – 17:00",

    "footer.contact": "Контакт",
    "footer.hours": "Часы",
    "footer.social": "Соцсети",
    "footer.legal": "Юридическое",

    "cookie.title": "Cookies и конфиденциальность",
    "cookie.body": "Мы используем только технически необходимые cookies для работы сайта. Без трекинга и аналитики. Подробнее в нашей",
    "cookie.privacy": "политике конфиденциальности",
    "cookie.accept": "Понятно",
    "cookie.more": "Подробнее",

    "buchung.title": "Заявка на приём",
    "buchung.step1": "Выбери услугу",
    "buchung.step2": "Дата и время",
    "buchung.step3": "Твои данные",
    "buchung.name": "Имя *",
    "buchung.email": "Email *",
    "buchung.phone": "Телефон *",
    "buchung.instagram": "Instagram (необязательно, напр. @username)",
    "buchung.notes": "Заметки (необязательно)",
    "buchung.agb_prefix": "Я прочитала",
    "buchung.agb_suffix": "и принимаю их.",
    "buchung.agb_view": "Условия",
    "buchung.submit": "Отправить заявку",
    "buchung.back": "Назад",
    "buchung.next": "Далее",
    "buchung.shore_hint": "Хочешь сразу гарантированную запись?",
    "buchung.shore_link": "Записаться через Shore",
    "buchung.shore_direct": "Записаться сразу гарантированно",
    "buchung.total": "Итого",
    "buchung.success": "Спасибо! Мы скоро свяжемся.",
    "buchung.multi_hint": "Можно выбирать несколько — сочетай услуги и дополнения свободно.",
    "buchung.date_label": "Дата",
    "buchung.time_label": "Время",
    "buchung.hours_hint": "Приём: пн–пт, 09:00–17:00.",
    "buchung.summary": "Обзор",
    "buchung.selected_services": "Услуги",
    "buchung.none_selected": "Ещё ничего не выбрано",
    "buchung.confirm_note": "Мы подтвердим приём по email.",
    "buchung.payment_note": "Оплата удобно на месте — картой или наличными.",
    "buchung.notice_title": "Обрати внимание:",
    "buchung.notice_body": "Эта запись — заявка без обязательств, ещё не подтверждённая. Мы проверим желаемую дату и подтвердим по email. Для сразу гарантированной записи оплати онлайн через Shore.",
    "buchung.err_service": "Выбери хотя бы одну услугу.",
    "buchung.err_datetime": "Выбери дату и время.",
    "buchung.err_required": "Заполни все обязательные поля.",
    "buchung.err_agb": "Прими условия, чтобы продолжить.",
    "buchung.error_generic": "Что-то пошло не так. Попробуй ещё раз.",
    "buchung.success_title": "Спасибо!",
    "buchung.success_body": "Мы получили твою заявку и ответим по email.",
    "buchung.success_cta": "На главную",

    "kontakt.title": "Контакт",
    "kontakt.hero": "Скажи привет.",
    "kontakt.subtitle": "Вопросы про процедуры, записи или обучение? Напиши — мы ответим как можно скорее.",
    "kontakt.name": "Имя",
    "kontakt.email": "Email",
    "kontakt.message": "Твоё сообщение",
    "kontakt.send": "Отправить",
    "kontakt.err_required": "Заполни все поля.",
    "kontakt.err_generic": "Что-то пошло не так. Попробуй ещё раз.",
    "kontakt.success": "Спасибо! Твоё сообщение получено.",

    "legal.notice": "По юридическим причинам текст ниже имеет силу только на немецком.",

    "packages.eyebrow": "Пакеты",
    "packages.title": "Beauty-пакеты",
    "packages.subtitle": "Четыре бережно продуманных ритуала — от натурального ухода до классического французского маникюра.",
    "packages.includes": "Включено",
    "packages.featured": "Хит",
    "packages.book": "Записаться на пакет",

    "pkg.pure.name": "Pure Care",
    "pkg.pure.tag": "Ухоженные руки и ноги — совсем без цвета.",
    "pkg.pure.body": "Идеальный пакет для тех, кто ценит естественную красоту, здоровые ногти и ухоженный вид в целом. Отлично подходит и для мужчин.",
    "pkg.pure.incl": "Русский маникюр · Русский педикюр",

    "pkg.natural.name": "Natural Luxury",
    "pkg.natural.tag": "Натурально. Вне времени. Элегантно.",
    "pkg.natural.body": "Идеальный выбор для тех, кто любит сдержанный образ. Стойкое наращивание в натуральном, молочном или розовом — в сочетании с ухоженным русским педикюром с Shellac.",
    "pkg.natural.incl": "Наращивание натуральное · Русский педикюр с Shellac",

    "pkg.signature.name": "Signature",
    "pkg.signature.tag": "Наш самый популярный beauty-пакет.",
    "pkg.signature.body": "Идеально для тех, кто хочет ухоженные руки и ноги с индивидуальным цветом. Гармоничный образ на любой случай.",
    "pkg.signature.incl": "Наращивание с покрытием цветом · Русский педикюр с Shellac",

    "pkg.elegant.name": "Elegant",
    "pkg.elegant.tag": "Вневременная классика для стильного образа.",
    "pkg.elegant.body": "Френч — это элегантность и точность. Пакет объединяет идеально смоделированные ногти и роскошный педикюр в классическом французском стиле.",
    "pkg.elegant.incl": "Наращивание френч · Русский педикюр с френчем",

    "countdown.days": "Дней",
    "countdown.hours": "Часов",
    "countdown.minutes": "Минут",
    "countdown.seconds": "Секунд",

    "locked.eyebrow": "Запись",
    "locked.title": "Скоро откроемся",
    "locked.body": "Онлайн-запись откроется 1 сентября 2026 — в день нашего открытия. Ждём тебя с нетерпением! 🌿",
    "locked.date": "01.09.2026",
    "locked.back": "На главную",

    "book.eyebrow": "Запись",
    "book.title": "Забронировать или в лист ожидания",
    "book.intro": "Все свободные слоты доступны прямо в Shore. Нет подходящего времени? Оставь заявку в листе ожидания — сообщим, как только освободится место.",
    "book.shore_eyebrow": "Мгновенная запись",
    "book.shore_title": "Свободные слоты в Shore",
    "book.shore_body": "Живой календарь со всеми доступными временами. Автоматическое подтверждение.",
    "book.shore_cta": "Записаться через Shore",
    "book.wl_eyebrow": "Лист ожидания",
    "book.wl_title": "Не нашли подходящее время?",
    "book.wl_body": "Не беда — оставь свои данные, и мы сообщим, как только появится место.",
    "book.wl_first": "Имя *",
    "book.wl_last": "Фамилия *",
    "book.wl_email": "Email *",
    "book.wl_phone": "Мобильный *",
    "book.wl_service_placeholder": "Желаемая услуга *",
    "book.wl_notes": "Комментарий (необязательно)",
    "book.wl_submit": "В лист ожидания",
    "book.wl_privacy": "Отправляя форму, ты соглашаешься на связь по указанным контактам. Подробности — в политике конфиденциальности.",
    "book.wl_success_title": "Ты в листе ожидания!",
    "book.wl_success_body": "Мы свяжемся, как только появится подходящее время. Спасибо за терпение! 🌿",

    "schulungen.eyebrow": "Обучение и академия",
    "schulungen.title": "Скоро",
    "schulungen.body": "Наши курсы и мастер-классы по русской технике маникюра готовятся к запуску. Запишись в лист ожидания и узнай первой, когда мы начнём.",
    "schulungen.email_placeholder": "Твой email",
    "schulungen.notify": "Сообщить",
    "schulungen.joined": "Спасибо — мы свяжемся с тобой. ✦",
    "schulungen.success_toast": "Ты в списке ожидания!",
    "schulungen.err_email": "Пожалуйста, введи email.",
    "schulungen.course_label": "Какой курс тебе интересен?",
    "schulungen.course_manikure": "Курс маникюра",
    "schulungen.course_pedikure": "Курс педикюра",
    "schulungen.err_course": "Пожалуйста, выбери курс.",
    "schulungen.err_name": "Пожалуйста, укажи имя и фамилию.",
    "schulungen.err_phone": "Пожалуйста, укажи действительный номер телефона.",

    "schulungen.hero_title_a": "Точная техника.",
    "schulungen.hero_title_b": "Профессиональная работа.",
    "schulungen.hero_title_c": "Твой следующий шаг.",
    "schulungen.hero_q": "Хочешь начать путь в бьюти-индустрии или усовершенствовать свою технику?",
    "schulungen.hero_body": "На наших индивидуальных курсах 1:1 ты освоишь точную, чистую и профессиональную работу — с большой практикой, личным сопровождением и особым вниманием к идеальному результату и гигиене.",
    "schulungen.cta_courses": "Смотреть курсы",
    "schulungen.cta_apply": "Оставить заявку",
    "schulungen.courses_eyebrow": "Наши курсы",
    "schulungen.courses_title": "Выбери свою технику",
    "schulungen.courses_note": "Все курсы проходят в формате личного интенсива 1:1 — даты по договорённости.",
    "schulungen.learn_label": "Чему ты научишься",
    "schulungen.c_hygiene": "Гигиеническая обработка инструментов (очистка, дезинфекция и стерилизация)",
    "schulungen.c1_name": "Аппаратный маникюр",
    "schulungen.c1_tag": "Russian Manicure · включая нанесение геля",
    "schulungen.c1_price": "899 €",
    "schulungen.c1_desc": "Интенсивный курс 1:1 – этот день принадлежит только тебе. Мы уделяем тебе столько внимания, что уже на следующий день ты сможешь работать со своими клиентками. Для всех, кто хочет точно и профессионально освоить аппаратный маникюр или усовершенствовать технику.",
    "schulungen.c1_b1": "Профессиональная подготовка натурального ногтя",
    "schulungen.c1_b2": "Точная обработка кутикулы",
    "schulungen.c1_b3": "Безопасная работа с фрезером и насадками",
    "schulungen.c1_b4": "Укрепление натурального ногтя гелем и чистое, контролируемое нанесение",
    "schulungen.c1_for": "Для новичков, вернувшихся в профессию и опытных мастеров маникюра.",
    "schulungen.c1_cta": "Заявка на курс маникюра",
    "schulungen.c2_name": "Аппаратный педикюр",
    "schulungen.c2_tag": "Russian Pedicure · включая нанесение Shellac",
    "schulungen.c2_price": "1.199 €",
    "schulungen.c2_desc": "Интенсивный курс 1:1 – этот день принадлежит только тебе. Мы уделяем тебе столько внимания, что уже на следующий день ты сможешь работать со своими клиентками. Профессиональный аппаратный педикюр – от точной обработки ногтей и кутикулы до ухоженной кожи стоп и идеального финиша Shellac.",
    "schulungen.c2_b1": "Точная обработка ногтей и кутикулы",
    "schulungen.c2_b2": "Профессиональная обработка огрубевшей кожи с подо-диском",
    "schulungen.c2_b3": "Бережная работа с сухими участками кожи",
    "schulungen.c2_b4": "Чистое и точное нанесение Shellac/гель-лака",
    "schulungen.c2_for": "Для новичков, вернувшихся в профессию, мастеров маникюра, косметологов и специалистов по уходу за стопами.",
    "schulungen.c2_cta": "Заявка на курс педикюра",
    "schulungen.incl_eyebrow": "Включено в стоимость",
    "schulungen.incl_title": "В каждый курс входит",
    "schulungen.incl1_title": "Интенсив 1:1",
    "schulungen.incl1_body": "Индивидуальное сопровождение и личная коррекция на протяжении всего курса.",
    "schulungen.incl2_title": "Стартовый набор",
    "schulungen.incl2_body": "Профессиональная базовая экипировка, с которой ты сможешь сразу закреплять полученные навыки.",
    "schulungen.incl3_title": "2 сертификата",
    "schulungen.incl3_body": "Профессиональный сертификат о пройденном курсе и отдельный сертификат о правильной обработке и стерилизации инструментов.",
    "schulungen.incl4_title": "Гигиена и обработка инструментов",
    "schulungen.incl4_body": "Профессиональная гигиена и структурированный процесс обработки — неотъемлемая часть твоего курса.",
    "schulungen.incl5_title": "1 год личной поддержки",
    "schulungen.incl5_body": "После курса ты не останешься одна. По вопросам освоенных техник ты можешь лично обращаться к нам в течение первого года.",
    "schulungen.philo_title": "Твой новый старт. Твоя техника. Твой путь.",
    "schulungen.philo_p1": "Для нас важно, чтобы ты учила не отдельные движения, а понимала, что делаешь и почему.",
    "schulungen.philo_p2": "Поэтому наши курсы проходят исключительно в личном формате 1:1. Так мы можем индивидуально учитывать твой уровень, стиль работы и вопросы.",
    "schulungen.philo_p3": "Неважно, начинаешь ли ты с нуля или хочешь вывести технику на новый уровень — мы целенаправленно работаем над твоими навыками и личным прогрессом.",
    "schulungen.closing": "Знания, точность и качество, которые останутся с тобой надолго.",
    "schulungen.form_eyebrow": "Заявка",
    "schulungen.form_title": "Забронируй место на курсе",
    "schulungen.form_body": "Выбери курс и оставь свои данные — мы лично свяжемся с тобой и предложим даты.",
    "schulungen.dates_eyebrow": "Даты · зима 2026",
    "schulungen.dates_title": "Выбери день курса",
    "schulungen.dates_note": "В каждую дату проходит только один курс — маникюр или педикюр, лишь одна ученица в день. Занятая дата больше недоступна для брони.",
    "schulungen.dates_start": "Начало: 9:00",
    "schulungen.dates_break": "Перерыв 1–1,5 часа включён",
    "schulungen.dates_food": "Питание предоставляется",
    "schulungen.dates_bring_label": "Что взять с собой",
    "schulungen.dates_bring": "Хорошее настроение и открытую, ясную голову для нового.",
    "schulungen.book_now": "Забронировать",
    "schulungen.book_c1": "Забронировать курс маникюра",
    "schulungen.book_c2": "Забронировать курс педикюра",
    "schulungen.dates_enquire": "Сначала оставить заявку",
    "academy.dialog_title": "Запись на курс",
    "academy.choose_date": "Выбери дату",
    "academy.date_taken": "занято",
    "academy.payment_label": "Вариант оплаты",
    "academy.pay_full": "Полная сумма",
    "academy.pay_full_note": "Один платёж — и готово",
    "academy.pay_deposit": "Предоплата · 30%",
    "academy.pay_deposit_note": "Остаток (70%) – удобно онлайн, ссылка на оплату придёт по e-mail за 7 дней до курса",
    "academy.to_checkout": "Перейти к безопасной оплате",
    "academy.secure_note": "Безопасная оплата через Stripe · без НДС согласно § 19 UStG",
    "academy.err_date": "Пожалуйста, выбери дату.",
    "academy.err_payment": "Пожалуйста, выбери вариант оплаты.",
    "academy.err_taken": "Эта дата только что занята — пожалуйста, выбери другую.",
    "academy.agb_link": "условия",
    "academy.street": "Улица и номер дома *",
    "academy.zip": "Индекс *",
    "academy.city": "Город *",
    "academy.err_address": "Пожалуйста, укажи полный адрес (улицу, индекс, город).",
    "academy.success_title": "Запись подтверждена",
    "academy.success_body": "Оплата прошла успешно — твоё место на курсе закреплено. Скоро ты получишь подтверждение по email. Ждём тебя!",
    "academy.success_checking": "Подтверждаем оплату …",
    "academy.success_failed": "Не удалось подтвердить оплату. Напиши нам — мы сразу проверим.",
    "academy.cancel_title": "Оплата отменена",
    "academy.cancel_body": "Ничего страшного — деньги не списаны, дата снова свободна.",
    "academy.back": "Назад к Academy",
    "schulungen.err_generic": "Что-то пошло не так. Попробуй ещё раз.",

    "faq.eyebrow": "Полезно знать",
    "faq.title": "Частые вопросы",
    "faq.subtitle": "Всё важное о твоём визите в студию — и если что-то осталось неясным:",
    "faq.subtitle_cta": "Напиши нам",
    "faq.q1": "Что такое русский маникюр?",
    "faq.a1": "Русский маникюр — это точная сухая техника: кутикула обрабатывается тонкими фрезами с точностью до миллиметра и аккуратно срезается. Результат — особенно чистая ногтевая пластина: покрытие наносится до самого края, и ногти дольше выглядят ухоженными.",
    "faq.q2": "Как долго держится маникюр?",
    "faq.a2": "Обычно 2–4 недели — у каждой клиентки индивидуально. Затем натуральный ноготь заметно отрастает, и мы рекомендуем новое моделирование.",
    "faq.q3": "Это больно?",
    "faq.a3": "Нет. Техника очень бережная, мы работаем спокойно и аккуратно. Большинство клиентов даже воспринимают визит как небольшой расслабляющий отдых.",
    "faq.q4": "Как в студии обеспечивается гигиена?",
    "faq.a4": "Гигиена — наш главный приоритет: все инструменты дезинфицируются и стерилизуются после каждого приёма, а одноразовые материалы используются только один раз для каждого клиента. «Где гигиена встречается с эстетикой» — наша повседневность.",
    "faq.q5": "Сколько длится приём?",
    "faq.a5": "В зависимости от услуги — примерно от 30 до 150 минут. Русский маникюр занимает около 30 минут, наращивание с цветом чуть дольше — мы сознательно уделяем время каждой детали.",
    "faq.q6": "Как я могу оплатить?",
    "faq.a6": "Удобно на месте — картой или наличными.",
    "faq.q7": "Могу ли я перенести или отменить запись?",
    "faq.a7": "Да, конечно — бесплатно за 48 часов до приёма. Просто напиши нам, и мы вместе подберём новое время.",
    "faq.q8": "Подходит ли маникюр мужчинам?",
    "faq.a8": "Безусловно! Ухоженные руки вне времени — русский маникюр без покрытия идеально подходит всем, кто хочет естественные, аккуратные ногти.",
  },
};

export const LANGUAGES = [
  { code: "de", label: "DE", full: "Deutsch" },
  { code: "en", label: "EN", full: "English" },
  { code: "ru", label: "RU", full: "Русский" },
];

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "de";
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && DICT[stored]) return stored;
    const nav = (navigator.language || "de").toLowerCase().slice(0, 2);
    return DICT[nav] ? nav : "de";
  });

  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
    try { localStorage.setItem(STORAGE_KEY, lang); } catch {}
  }, [lang]);

  const setLang = useCallback((code) => {
    if (DICT[code]) setLangState(code);
  }, []);

// Bis inkl. 01.09.2026 zeigen wir die Eröffnungs-Tagline; ab 02.09.2026 den Slogan.
const OPENING_END = new Date("2026-09-01T23:59:59+02:00").getTime();

  const t = useCallback(
    (key) => {
      let effectiveKey = key;
      if (key === "hero.tagline" && Date.now() <= OPENING_END) {
        effectiveKey = "hero.tagline_opening";
      }
      return (DICT[lang] && DICT[lang][effectiveKey]) || DICT.de[effectiveKey] || DICT.de[key] || key;
    },
    [lang]
  );

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangCtx);
  if (!ctx) throw new Error("useLang must be used inside <LangProvider>");
  return ctx;
};
